module.exports = __webpack_public_path__ + "static/media/29.921d63e3.jpg";